<div *ngIf="isAuthCheckComplete && isAuthenticated && !isCallbackLoading; else loadingState" class="app-content">
  <!-- Show global loading overlay for logout and other operations -->
  <div *ngIf="globalLoadingState.isLoading" class="global-loading-overlay"
    [ngClass]="'loading-' + globalLoadingState.type">
    <div class="global-loading-content">
      <!-- Enhanced Signout Design -->
      <div *ngIf="globalLoadingState.type === 'logout'" class="signout-container">
        <div class="syngenta-logo-signout">
          <img src="assets/icons/icon-192x192.png" alt="Syngenta" />
        </div>
        <div class="signout-message">
          <h3>Goodbye, {{ currentUserName }}!</h3>
          <p>{{ globalLoadingState.message }}</p>
        </div>
        <div class="modern-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
        <div class="signout-footer">
          <p>Thank you for using Syngenta Premix Calculator</p>
        </div>
      </div>

      <!-- Default loading design for other types -->
      <div *ngIf="globalLoadingState.type !== 'logout'" class="default-loading">
        <div class="modern-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
        <p>{{ globalLoadingState.message }}</p>
      </div>
    </div>
  </div>

  <!-- Main app content -->
  <div [class.blur-content]="globalLoadingState.isLoading">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>

<ng-template #loadingState>
  <!-- Show callback loading if processing callback -->
  <div *ngIf="isCallbackLoading" class="callback-loading-overlay">
    <div class="callback-loading-content">
      <div class="syngenta-logo-signin">
        <img src="assets/icons/icon-192x192.png" alt="Syngenta" />
      </div>
      <div class="signin-message">
        <h3 *ngIf="currentUserName && (loadingMessage.includes('workspace') || loadingMessage.includes('Setting up'))">
          Welcome back, {{ currentUserName }}!</h3>
        <h3 *ngIf="currentUserName && loadingMessage.includes('dashboard')">Hello {{ currentUserName }}!</h3>
        <h3
          *ngIf="!currentUserName || (!loadingMessage.includes('workspace') && !loadingMessage.includes('Setting up') && !loadingMessage.includes('dashboard'))">
          Welcome to Syngenta!</h3>
        <p>{{ loadingMessage }}</p>
      </div>
      <div class="modern-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <div class="signin-footer">
        <p>Preparing your personalized experience...</p>
      </div>
    </div>
  </div>

  <!-- Show initial auth loading if not callback -->
  <div *ngIf="!isCallbackLoading" class="auth-loading-container">
    <div class="auth-loading-content">
      <div class="syngenta-logo">
        <img src="assets/icons/icon-192x192.png" alt="Syngenta" />
      </div>
      <div class="auth-message">
        <h3
          *ngIf="currentUserName && (loadingMessage.includes('Welcome back') || loadingMessage.includes('workspace') || loadingMessage.includes('dashboard'))">
          Welcome back, {{ currentUserName }}!</h3>
        <h3 *ngIf="currentUserName && loadingMessage.includes('Preparing')">Hello {{ currentUserName }}!</h3>
        <h3
          *ngIf="!currentUserName || (!loadingMessage.includes('Welcome back') && !loadingMessage.includes('workspace') && !loadingMessage.includes('dashboard') && !loadingMessage.includes('Preparing'))">
          Syngenta Premix Calculator</h3>
        <p class="loading-text">{{ loadingMessage }}</p>
      </div>
      <div class="modern-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <div class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<!-- Global toast container for interceptor notifications -->
<p-toast [preventOpenDuplicates]="true"></p-toast>
